export const validateDate = (value: string) => {
  const validateRegExp =
    /^\d{4}\/(0?[1-9]|1[0-2])\/((0?[1-9])|([1-2][0-9])|(3[01]))$/;
  return validateRegExp.test(value);
};
export const validateDateWithHyphen = (value: string) => {
  const validateRegExp =
    /^\d{4}-(0?[1-9]|1[0-2])-((0?[1-9])|([1-2][0-9])|(3[01]))$/;
  return validateRegExp.test(value);
};
